var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13175",
    "data-name": "Group 13175",
    transform: "translate(3906 -10965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_560",
    "data-name": "Ellipse 560",
    transform: "translate(-3903 10965)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_15",
    "data-name": "Subtraction 15",
    transform: "translate(-3906 10972)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,7H0A7,7,0,0,1,14,7Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.91710758209229 6.000200271606445 C 12.43961524963379 3.166164636611938 9.967968940734863 1.00000011920929 7.000200271606445 1.00000011920929 C 4.032346248626709 1.00000011920929 1.560825943946838 3.166026830673218 1.083328604698181 6.000200271606445 L 12.91710758209229 6.000200271606445 M 14.00040054321289 7.000200271606445 L 2.716064386731887e-07 7.000200271606445 C 2.716064386731887e-07 3.139830112457275 3.140730381011963 1.358032193365943e-07 7.000200271606445 1.358032193365943e-07 C 10.85974025726318 1.358032193365943e-07 14.00002002716064 3.139830112457275 14.00040054321289 6.999200344085693 L 14.00040054321289 7.000200271606445 Z",
    stroke: "none",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPerson);
export default __webpack_public_path__ + "static/media/filter-person.cc9a425bd66969cdae7dcd608f3c7b09.svg";
export { ForwardRef as ReactComponent };